import * as graphql from "../../resolvers-types";
import { generateUID } from "../library/utils";

export const ngEditorMenu: graphql.Menu = {
  Features: [
    {
      BottomIcon: null,
      Disabled: null,
      EndIcon: null,
      ExternalUrl: null,
      Id: "0xa201",
      Label: "Development",
      PageUrl: null,
      StartIcon: null,
      TopIcon: null,
      UrlOpenTarget: null,
      Visible: true,
      Features: [
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa231",
          Label: "Properties Editor",
          PageUrl: "/prop-editor",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa32",
          Label: "Menu Editor",
          PageUrl: "/menu-editor",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa21/2",
          Label: "Component Editor GUI",
          PageUrl: "/local/component-editor-gui",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa21/22342",
          Label: "Component Preview",
          PageUrl: "/component-preview",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa32aaa",
          Label: "Component Manager",
          PageUrl: "/component-manager",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa33aaa",
          Label: "Page Manager",
          PageUrl: "/page-manager",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa32aaar",
          Label: "Theme Manager",
          PageUrl: "/theme-manager",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa32aaare",
          Label: "Site Manager",
          PageUrl: "/site-manager",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa32aaarsse",
          Label: "Template Manager",
          PageUrl: "/template-manager",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa32wwaaare",
          Label: "Style Editor",
          PageUrl: "/style-editor",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xb42wwaaare",
          Label: "Format Editor",
          PageUrl: "/format-editor",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa32a",
          Label: "Asset Manager",
          PageUrl: "/asset-manager",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa32aab",
          Label: "Service Manager",
          PageUrl: "/service-manager",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa32aabc",
          Label: "Plugin Manager",
          PageUrl: "/plugin-manager",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xadddd32aaare",
          Label: "Locale Manager",
          PageUrl: "/locale-manager",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa31",
          Label: "Data Model Editor",
          PageUrl: "/data-model-editor",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
      ],
    },
    {
      Id: "0xasdwdsasd20",
      Label: "Components",
      Visible: true,
      Features: [
        {
          Id: "0xwera342w1",
          Label: "Component Catalog",
          PageUrl: "/product-catalog",
          Visible: true,
        },
        {
          Id: "0xa342w1",
          Label: "Component Feedback",
          PageUrl: "/dashboard-review-by-widget",
          Visible: true,
        },
      ],
    },
    {
      BottomIcon: null,
      Disabled: null,
      EndIcon: null,
      ExternalUrl: null,
      Id: "0xasdwsd20",
      Label: "Examples",
      PageUrl: null,
      StartIcon: null,
      TopIcon: null,
      UrlOpenTarget: null,
      Visible: true,
      Features: [
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa3421",
          Label: "Manual Feed",
          PageUrl: "/main-feed",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa342",
          Label: "User Profile Feed",
          PageUrl: "/user-feed",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa34a1",
          Label: "All Component Test",
          PageUrl: "/comp-test",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa33",
          Label: "Repeater Example",
          PageUrl: "/site-keyapp",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa343",
          Label: "Login Page Example",
          PageUrl: "/login-page",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa34312",
          Label: "Grid Test",
          PageUrl: "/grid-test",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa3431",
          Label: "Complex Form",
          PageUrl: "/form-test",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa342231",
          Label: "Excel List",
          PageUrl: "/excel-list",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa343ss2",
          Label: "Flex Layout",
          PageUrl: "/flex-test",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa34321",
          Label: "Nested Components",
          PageUrl: "/component-nesting-test",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa3433",
          Label: "Reviewer Feedback Layout",
          PageUrl: "/reviewer-feedback-layout",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa3434",
          Label: "Article Full Page",
          PageUrl: "/article-fullpage",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa343122",
          Label: "Sample Components",
          PageUrl: "/sample-components",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa3435",
          Label: "Style Layout",
          PageUrl: "/style-test",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
        {
          BottomIcon: null,
          Disabled: null,
          EndIcon: null,
          ExternalUrl: null,
          Features: null,
          Id: "0xa343222",
          Label: "Single Hierarhcy",
          PageUrl: "/single-hierarchy",
          StartIcon: null,
          TopIcon: null,
          UrlOpenTarget: null,
          Visible: true,
        },
      ],
    },
  ],
  Id: "custom-menu",
  Description: null,
  Name: "Custom Menu",
  __typename: "Menu",
};

export const generateFeature = () => ({
  BottomIcon: null,
  Disabled: null,
  EndIcon: null,
  ExternalUrl: null,
  Features: null,
  Id: generateUID(),
  Label: "New Feature",
  __typename: "Feature",
  PageUrl: null,
  StartIcon: null,
  TopIcon: null,
  UrlOpenTarget: null,
  Visible: true,
});
